import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

const errMsg = (err, fallback) =>
  err.response?.data?.message ||
  err.response?.data?.errors?.[0]?.message ||
  err.message ||
  fallback;

// /api/devices is auto-scoped to the caller's company on the server.
export const fetchMyDevices = createAsyncThunk(
  "devices/myFetch",
  async (params = {}, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/devices", { params });
      return data.data;
    } catch (err) {
      return rejectWithValue(errMsg(err, "Failed to load devices"));
    }
  }
);

const slice = createSlice({
  name: "devices",
  initialState: {
    items: [],
    pagination: { page: 1, limit: 25, total: 0, pages: 0 },
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchMyDevices.pending, (s) => {
      s.loading = true;
      s.error = null;
    })
      .addCase(fetchMyDevices.fulfilled, (s, a) => {
        s.loading = false;
        s.items = a.payload.items;
        s.pagination = a.payload.pagination;
      })
      .addCase(fetchMyDevices.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload;
      });
  },
});

export default slice.reducer;
